import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64374658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headerContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "headerRightContainer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yuyan1" }, null, -1))
const _hoisted_5 = { class: "headerText" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon_down_arrow icon-houyigeyouzineirong" }, null, -1))

import {
  onMounted,
  ref,
} from 'vue';
import {transformI18n, i18n} from '@/langs/i18n';
import {useSettingStore} from '@/stores/setting';
import {sysCfgGet} from '@/api/sysCfg';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useSettingStore();
const webLogo = ref('');

const handleCommand = (command: string) => {
  i18n.global.locale.value = command;
  store.setLang(command);
};

onMounted(() => {
  getSysCfg();
});

const getSysCfg = async () => {
  try {
    const res = await sysCfgGet();
    webLogo.value = res.data.data?.picture?.webLogo;
    const sysName = res.data.data?.sysName || '';
    document.title = sysName;
    store.setSysName(sysName);
  } catch {
    // do nothing.
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (webLogo.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/",
            style: {"margin-left":"30px","display":"inline-block"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: webLogo.value,
                alt: "logo",
                style: {"height":"40px"}
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_dropdown, {
        onCommand: handleCommand,
        placement: "bottom",
        class: "localWrapper"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "zh" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('language.chinese')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "en" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('language.english')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(transformI18n)('home.selectLanguage')), 1),
            _hoisted_6
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})